(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root && root.document && root.MarketCurrency) {
    api.start(root, root.MarketCurrency);
  }
})(typeof window !== 'undefined' ? window : undefined, function () {
  var ZERO_DECIMAL = {
    BIF: 1,
    CLP: 1,
    DJF: 1,
    GNF: 1,
    JPY: 1,
    KMF: 1,
    KRW: 1,
    MGA: 1,
    PYG: 1,
    RWF: 1,
    UGX: 1,
    VND: 1,
    VUV: 1,
    XAF: 1,
    XOF: 1,
    XPF: 1,
  };

  var PLACEHOLDERS = [
    'amount_no_decimals_with_comma_separator',
    'amount_no_decimals_with_space_separator',
    'amount_with_comma_separator',
    'amount_with_space_separator',
    'amount_with_apostrophe_separator',
    'amount_with_period_and_space_separator',
    'amount_no_decimals',
    'amount',
  ];

  var NUMBER_PATTERNS = {
    amount_with_comma_separator: '(?:\\d{1,3}(?:\\.\\d{3})+|\\d+)(?:,\\d{1,2})?',
    amount_no_decimals_with_comma_separator: '(?:\\d{1,3}(?:\\.\\d{3})+|\\d+)',
    amount_with_space_separator: '(?:\\d{1,3}(?:[\\s\\u00A0\\u202F]\\d{3})+|\\d+)(?:,\\d{1,2})?',
    amount_no_decimals_with_space_separator: '(?:\\d{1,3}(?:[\\s\\u00A0\\u202F]\\d{3})+|\\d+)',
    amount_with_apostrophe_separator: "(?:\\d{1,3}(?:'\\d{3})+|\\d+)(?:\\.\\d{1,2})?",
    amount_with_period_and_space_separator: '(?:\\d{1,3}(?:[\\s\\u00A0\\u202F]\\d{3})+|\\d+)(?:\\.\\d{1,2})?',
    amount_no_decimals: '(?:\\d{1,3}(?:,\\d{3})+|\\d+)',
    amount: '(?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d{1,2})?',
  };

  var SKIP =
    'script, style, textarea, noscript, template, klarna-placement, shopify-payment-terms, #product-form-installment, price-range, .facets__price, [data-market-currency-skip]';

  function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function plainFormat(format) {
    return String(format || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|&#160;/gi, ' ');
  }

  function detectPlaceholder(format) {
    for (var i = 0; i < PLACEHOLDERS.length; i++) {
      if (format.indexOf('{{' + PLACEHOLDERS[i] + '}}') !== -1) return PLACEHOLDERS[i];
    }
    return null;
  }

  function buildMatcher(format) {
    var plain = plainFormat(format);
    var placeholder = detectPlaceholder(plain);
    if (!placeholder) return null;
    var token = '{{' + placeholder + '}}';
    var parts = plain.split(token);
    var flex = function (part) {
      return escapeRegex(part).replace(/ +/g, '\\s*');
    };
    return {
      placeholder: placeholder,
      regex: new RegExp(flex(parts[0]) + '(' + NUMBER_PATTERNS[placeholder] + ')' + flex(parts.slice(1).join(token)), 'g'),
    };
  }

  function parseAmount(raw, placeholder) {
    var normalized = raw;
    if (
      placeholder === 'amount_with_comma_separator' ||
      placeholder === 'amount_no_decimals_with_comma_separator'
    ) {
      normalized = raw.replace(/\./g, '').replace(',', '.');
    } else if (
      placeholder === 'amount_with_space_separator' ||
      placeholder === 'amount_no_decimals_with_space_separator'
    ) {
      normalized = raw.replace(/[\s\u00A0\u202F]/g, '').replace(',', '.');
    } else if (placeholder === 'amount_with_apostrophe_separator') {
      normalized = raw.replace(/'/g, '');
    } else if (placeholder === 'amount_with_period_and_space_separator') {
      normalized = raw.replace(/[\s\u00A0\u202F]/g, '');
    } else {
      normalized = raw.replace(/,/g, '');
    }
    var amount = Number(normalized);
    return Number.isFinite(amount) ? amount : NaN;
  }

  function createConverter(config) {
    var rate = Number(String(config.rate).replace(',', '.'));
    var currency = String(config.currency || '').toUpperCase();
    var digits = ZERO_DECIMAL[currency] ? 0 : 2;
    var matchers = [];
    var seen = {};
    [config.moneyFormat, config.moneyWithCurrencyFormat].forEach(function (format) {
      var matcher = buildMatcher(format);
      if (!matcher) return;
      var key = matcher.regex.source;
      if (seen[key]) return;
      seen[key] = true;
      matchers.push(matcher);
    });
    matchers.sort(function (a, b) {
      return b.regex.source.length - a.regex.source.length;
    });

    var formatter;
    try {
      formatter = new Intl.NumberFormat(config.locale || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });
    } catch (error) {
      formatter = null;
    }

    function formatCurrency(amount) {
      var factor = Math.pow(10, digits);
      var rounded = Math.round((amount + Number.EPSILON) * factor) / factor;
      if (formatter) return formatter.format(rounded);
      return rounded.toFixed(digits) + ' ' + currency;
    }

    function convertString(text) {
      if (!text) return text;
      var next = text;
      matchers.forEach(function (matcher) {
        matcher.regex.lastIndex = 0;
        next = next.replace(matcher.regex, function (match, amount) {
          var euros = parseAmount(amount, matcher.placeholder);
          if (!Number.isFinite(euros)) return match;
          return formatCurrency(euros * rate);
        });
      });
      return next;
    }

    function formatFromCents(cents) {
      var value = Number(cents);
      if (!Number.isFinite(value)) return '';
      return formatCurrency((value / 100) * rate);
    }

    return {
      convertString: convertString,
      formatFromCents: formatFromCents,
    };
  }

  function shouldSkip(element) {
    return !element || (element.closest && element.closest(SKIP));
  }

  function walk(node, convertString) {
    if (!node) return;
    if (node.nodeType === 3) {
      if (shouldSkip(node.parentElement)) return;
      var updated = convertString(node.nodeValue);
      if (updated !== node.nodeValue) node.nodeValue = updated;
      return;
    }
    if (node.nodeType !== 1 || shouldSkip(node)) return;
    var children = node.childNodes;
    for (var i = 0; i < children.length; i++) walk(children[i], convertString);
  }

  function flattenSplitPrices(root, convertString) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.price-item, .money, .totals__subtotal-value, .totals__total-value').forEach(function (element) {
      if (shouldSkip(element) || element.childElementCount === 0 || element.textContent.length > 80) return;
      var updated = convertString(element.textContent);
      if (updated !== element.textContent) element.textContent = updated;
    });
  }

  function convertRoot(root, convertString) {
    walk(root, convertString);
    if (root.nodeType === 1) flattenSplitPrices(root, convertString);
    else if (root.parentElement) flattenSplitPrices(root.parentElement, convertString);
  }

  function start(windowRef, config) {
    if (!config || !config.active || !windowRef.document) return;
    var currency = String(config.currency || '').toUpperCase();
    var rate = Number(String(config.rate).replace(',', '.'));
    if (!/^[A-Z]{3}$/.test(currency) || !Number.isFinite(rate) || rate <= 0) return;

    var converter = createConverter(config);
    var documentRef = windowRef.document;
    var scheduled = false;
    var queued = [];
    var observer;

    function insertCartNotice() {
      if (!config.notice) return;
      var footer = documentRef.querySelector('#slidecarthq footer, #slidecarthq .footer');
      if (!footer || footer.querySelector('.market-currency-notice')) return;
      var note = documentRef.createElement('p');
      note.className = 'market-currency-notice caption';
      note.setAttribute('data-market-currency-skip', '');
      note.textContent = config.notice;
      footer.prepend(note);
    }

    function flush() {
      var batch = queued;
      queued = [];
      scheduled = false;
      if (observer) observer.disconnect();
      batch.forEach(function (node) {
        convertRoot(node, converter.convertString);
      });
      insertCartNotice();
      if (observer && documentRef.body) {
        observer.observe(documentRef.body, { subtree: true, childList: true, characterData: true });
      }
    }

    function enqueue(node) {
      if (!node) return;
      queued.push(node);
      if (scheduled) return;
      scheduled = true;
      windowRef.requestAnimationFrame(flush);
    }

    function installFormatPrice() {
      if (typeof windowRef.formatPrice !== 'function' || windowRef.formatPrice.__marketCurrency) return;
      var wrapped = function (cents) {
        return converter.formatFromCents(cents);
      };
      wrapped.__marketCurrency = true;
      windowRef.formatPrice = wrapped;
    }

    function installFormatMoney() {
      if (!windowRef.Shopify || typeof windowRef.Shopify.formatMoney !== 'function' || windowRef.Shopify.formatMoney.__marketCurrency) {
        return;
      }
      var wrapped = function (cents) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        return converter.formatFromCents(cents);
      };
      wrapped.__marketCurrency = true;
      windowRef.Shopify.formatMoney = wrapped;
    }

    installFormatPrice();
    installFormatMoney();
    enqueue(documentRef.body);

    observer = new MutationObserver(function (mutations) {
      installFormatPrice();
      installFormatMoney();
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          enqueue(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(enqueue);
      });
    });

    if (documentRef.body) {
      observer.observe(documentRef.body, { subtree: true, childList: true, characterData: true });
    }
  }

  return {
    createConverter: createConverter,
    start: start,
  };
});
